// extracted by mini-css-extract-plugin
export var controls = "secondary-blocks-module--controls--d9510";
export var navButton = "secondary-blocks-module--navButton--6b08d";
export var secondaryBlock = "secondary-blocks-module--secondaryBlock--93917";
export var secondaryBlocks = "secondary-blocks-module--secondaryBlocks--5c763";
export var secondaryBlocksWrapper = "secondary-blocks-module--secondaryBlocksWrapper--4f37e";